import Vue from 'vue';

const COOKIE = 'theme';
const COOKIE_OPTS = { path: '/', maxAge: 60 * 60 * 24 * 365, sameSite: 'lax' };

function applyDom(isDark) {
    if (!process.client) return;
    document.documentElement.classList.toggle('dark', isDark);
}

export default ({ $cookies }, inject) => {
    const isDark = $cookies.get(COOKIE) === 'dark';
    const state = Vue.observable({ value: isDark ? 'dark' : 'light' });

    applyDom(isDark);

    const colorMode = {
        get value() {
            return state.value;
        },
        get isDark() {
            return state.value === 'dark';
        },
        set(mode) {
            const next = mode === 'dark' ? 'dark' : 'light';
            state.value = next;
            $cookies.set(COOKIE, next, COOKIE_OPTS);
            applyDom(next === 'dark');
        },
        toggle() {
            this.set(state.value === 'dark' ? 'light' : 'dark');
        },
    };

    inject('colorMode', colorMode);
};
